import $ from 'jquery';
import { checkAndHideZeroReviewElements } from './utils';
import './visual-nav';
import 'styleguide/modules/product-filter-search';
import './plp-lazy-load';
import './size-selection';
import './add-to-bag';
import './notify-me';
import './filter-search';
import revieveTryOn from '../../modules/revieve-try-on';
window.revieveTryOn = revieveTryOn;
import { renderPlpSocialProof } from '../../modules/social-proof';
import { addToBagWithData } from 'modules/add-to-bag';
import './loyalty-favorites';

window.initPlpLazyLoad = function() {
    $('.js-plp-lazy-load').plpLazyLoad({
        sessionName: 'plpSessionData',
        loadAfterCallback: function() {
            $('.js-lazy-image').lazy({
                bind: "event",
                effect: "fadeIn",
                threshold: 1500,
            });
            if(window.bindHeartEvent) {
                window.bindHeartEvent($('.js-favorite-button'));
            }
            if(window.bindColorSwatchEvent) {
                window.bindColorSwatchEvent();
            }
            $('.js-select-size').sizeSelection();
            $('.js-plp-add-to-bag').plpAddToBag();
            $('.js-notify-me').plpNotifyMe();

            revieveTryOn({
                isPlp: true,
                checkAvailability: true,
            });

            $('.js-lazy-video').each(function() {
              this.play();
            });

            renderPlpSocialProof($('.js-plp-container').toArray().map((el) => $(el).prop('id')));
        }
    });
}

window.initRemoveFromFavListHandler = function() {
  $('.js-remove-from-fav-list').on('click', function() {
    const $this = $(this);
    const description = $(this).data('description');
    $('#undo-remove-link').data('id' , $this.data('listid')).data('code', $this.data('code'));
    $.ajax({
      url: "/content/favorites/mylist/removeproduct/" + $this.data('listid') + "/" + $this.data('code'),
      type: "POST",
      success: function () {
        $('#js-removed-item-title').text(description);
        $.modal({
          open: "removed-item-notification",
          type: "notification",
          triggerOpen: true,
          onOpen: function () {
            $this.parents('.js-plp-container').hide();
            let count = $('#filtered_fav_count').data('count');
            let newCount = count - 1 ;
            let text = $('#filtered_fav_count').text();
            text = text.replace(count, newCount);
            $('#filtered_fav_count').text(text).data('count', newCount);
            if(newCount == 0){
              window.location.reload();
            }
          }
        })
      }
    });
  });
}

window.initPlpCtas = function() {
    $('.js-select-size').sizeSelection();
    $('.js-plp-add-to-bag').plpAddToBag();
    $('.js-notify-me').plpNotifyMe();
}

// Requires for Zelig Add to Cart integration
window.addToBagWithData = addToBagWithData;

$(function(){
  initPlpLazyLoad();
  initPlpCtas();
  $('.js-product-filter-search').productFilterSearch()

  /*
   * Favorites PLP - removing item from list
   */
  initRemoveFromFavListHandler();

  /*
   * Favorites PLP - edit favorite list name
   */

  $('.js-edit-fav-list-name').on('click', function() {
    const listID = $(this).data('id');
    $.modal({
      url: '/content/favorites/mylist/popupMarkup/renameList?listName=' + encodeURIComponent($(this).data('listname')),
      type: 'small',
      triggerOpen: true,
      onComplete: function () {
        $('.js-edit-fav-list-name-form').on('submit', function (e) {
          e.preventDefault();
          const errorMsg = $('#rename-error-msg');
          const $listNameInput = $('#list-name');
          const $listNameField = $listNameInput.closest('.field');
          $listNameField.removeClass('is-error');
          let newName = $listNameInput.val();
          if (newName.trim() !== "") {
            $.ajax({
              url: "/content/favorites/mylist/rename/"+ listID + "?newName=" + encodeURIComponent(newName),
              type: "POST",
              success: function (listData) {
                  $listNameField.removeClass('is-error');
                  if (listData.errorMessage) {
                      errorMsg.html(listData.errorMessage);
                      $listNameField.addClass('is-error');
                  } else {
                      $.modal.close();
                      $.modal({
                          open: 'list-name-updated-notification',
                          type: 'notification',
                          triggerOpen: true,
                      });
                      $("#listName").text(newName);
                      $('.js-left-nav-container').find('a.active').text(newName).attr('title', newName);
                      $('.js-delete-fav-list').data('listname', newName);
                  }
              }
            });
          } else {
              errorMsg.html('Please enter a list name.');
              $listNameField.addClass('is-error');
          }
        })
      }
    })
  })

  /*
  * GRLFRND PLP AB Test - Scroll to Products
  */
  let scrollToID = $('#jump-to-products');
  if (scrollToID.length) {
    $('html').css({'scroll-behavior': 'smooth', 'scroll-padding-top': '10rem'});
  }

  /*
   * Favorites PLP - delete favorite list
   */

  $('.js-delete-fav-list').on('click', function(){
    const listID = $(this).data('id');
    $.modal({
      url: '/content/favorites/mylist/popupMarkup/deleteListConfirm?listName=' + encodeURIComponent($(this).data('listname')),
      type: 'small',
      triggerOpen: true,
      onComplete: function() {
        $('.js-delete-fav-list-form').on('submit', function(e) {
          e.preventDefault();
          $.ajax({
            url: '/content/favorites/mylist/delete/' + listID,
            type: 'POST',
            success: function () {
              $.modal.close();
              $.modal({
                open: 'list-deleted-notification',
                type: 'notification',
                triggerOpen: true,
              })
              $('.js-left-nav-container').find('a.active').remove();
              if($('.js-left-nav-container').find('.ui-list>li>a').length){
                  $('.js-left-nav-container').find('.ui-list>li>a')[0].click();
              } else{
                  window.location.href= "/content/favorites/mylist/";
              }
            }
          });
        })
      }
    })
  });
  $('#undo-remove-link').on('click', function(){
    const code =$(this).data('code');
    $.ajax({
      url: "/content/favorites/mylist/addproduct/" + $(this).data('id')+ "/" +$(this).data('code'),
      type: "POST",
      success: function () {
        $('#' + code).show();
        let count = $('#filtered_fav_count').data('count');
        let text = $('#filtered_fav_count').text();
        text = text.replace(count, count + 1)
        $('#filtered_fav_count').text(text).data('count', count + 1);
      }
    });
  });

  /*
   * Fit Predictor adding tabbing capabilities
   */
  $('.fp-root .fp-cta').attr('tabindex', 0);

    revieveTryOn({
        isPlp: true,
        checkAvailability: !$('.js-plp-lazy-load').length,
    });
});  

document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(function(mutationsList, observer) {
    checkAndHideZeroReviewElements();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check
  checkAndHideZeroReviewElements();
});

document.addEventListener('WidgetModalOpen', function(e) {
    logEngagement(window.location.href, 'Zelig', 'PLP widget clicks');
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/index.js